module.exports = __webpack_public_path__ + "img/zxlogo.3746b198.png";